<template>
  <v-container fluid grid-list-md>
    <v-slide-y-transition mode="out-in">
      <v-layout column align-start>
        <v-flex d-flex xs12 sm12 pa-2>
          <h2 class="title">{{ $vuetify.t('$vuetify.AdminPhaseTime.phaseWorking') }}</h2>
        </v-flex>
        <v-flex d-flex xs12 sm12 pa-2>
          <v-text-field
            :label="$vuetify.t('$vuetify.AdminPhaseTime.days')"
            v-model='phaseWorking'
            :error-messages="!this.isInteger(phaseWorking) ? $vuetify.t('$vuetify.AdminPhaseTime.isNotInteger') : null"
          ></v-text-field>
        </v-flex>
        <v-flex d-flex xs12 sm12 pa-2>
          <h2 class="title">{{ $vuetify.t('$vuetify.AdminPhaseTime.phaseVoting') }}</h2>
        </v-flex>
        <v-flex d-flex xs12 sm12 pa-2>
          <v-text-field
            :label="$vuetify.t('$vuetify.AdminPhaseTime.days')"
            v-model='phaseVoting'
            :error-messages="!this.isInteger(phaseVoting) ? $vuetify.t('$vuetify.AdminPhaseTime.isNotInteger') : null"
          ></v-text-field>
        </v-flex>
        <v-flex d-flex xs12 sm12 pa-2>
          <v-switch
              v-for="(p, index) in phases"
              v-model="phasesSelected"
              :key="phases.p"
              @change="updatePhases"
              :label="$vuetify.t('$vuetify.TopicPhase.' + p)"
              :value="p"></v-switch>
        </v-flex>
        <v-flex d-flex xs12 sm12 pa-2>
          <v-btn
            @click="submit"
          >
          {{ $vuetify.t('$vuetify.UserSettings.save') }}
          </v-btn>
        </v-flex>
      </v-layout>
    </v-slide-y-transition>
  </v-container>
</template>

<script>

import api from '@/api'

export default {
  name: 'Phase',
  data: function () {
    return {
      phases: this.$store.getters.phases,
      phasesSelected: []
    }
  },

  beforeMount: function () {
    if (Object.keys(this.$store.getters.schoolConfig).indexOf('phases') >= 0) {
      this.phasesSelected = this.$store.getters.schoolConfig.phases
    }
  },

  computed: {
    phaseVoting: {
      get () { return (this.$store.getters.schoolConfig.phaseVoting) ? this.$store.getters.schoolConfig.phaseVoting : 1 },
      set (value) {
        if (value) {
          this.$store.commit('UPDATE_SCHOOL_CONFIG_KEY', {key: 'phaseVoting', value: value})
        }
      }
    },
    phaseWorking: {
      get () { return (this.$store.getters.schoolConfig.phaseWorking) ? this.$store.getters.schoolConfig.phaseWorking : 1 },
      set (value) {
        if (value) {
          this.$store.commit('UPDATE_SCHOOL_CONFIG_KEY', {key: 'phaseWorking', value: value})
        }
      }
    }
  },

  props: {
  },

  methods: {
    isInteger: function (val) { return !isNaN(val) && Number.isInteger(parseInt(val)) },
    updatePhases: function () {
      const phaseOrder = this.$store.getters.phaseOrder
      const byPhase = (a, b) => {
        if (phaseOrder[a] === phaseOrder[b]) return 0
        return phaseOrder[a] > phaseOrder[b] ? 1 : -1
      }
      this.phasesSelected.sort(byPhase)
      this.$store.commit('UPDATE_SCHOOL_CONFIG_KEY', {key: 'phases', value: this.phasesSelected})
    },

    submit: function () {
      // this.$store.commit('UPDATE_SCHOOL_CONFIG_KEY', {key: phase})
      const phasesSelected = this.phasesSelected.filter(p => this.phases.indexOf(p) !== -1)

      api.school.updateConfig(this.$store.getters.selected_school, 'phaseWorking', this.phaseWorking)
        .then(() => {
          api.school.updateConfig(this.$store.getters.selected_school, 'phaseVoting', this.phaseVoting)
          api.school.updateConfig(this.$store.getters.selected_school, 'phases', phasesSelected)
        })
    }
  }
}
</script>
